import { render, staticRenderFns } from "./UAT.vue?vue&type=template&id=0eff8c57&scoped=true&lang=pug&"
import script from "./UAT.vue?vue&type=script&lang=js&"
export * from "./UAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff8c57",
  null
  
)

export default component.exports